module.exports = __webpack_public_path__ + "img/16.6d4c9a62.jpg";